const advertsActionTypes = {
  FETCH_ADVERTS_LIST: 'FETCH_ADVERTS_LIST',
  FETCH_ADVERTS_LIST_SUCCESS: 'FETCH_ADVERTS_LIST_SUCCESS',
  FETCH_ADVERTS_LIST_FAIL: 'FETCH_ADVERTS_LIST_FAIL',

  FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION: 'FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION',
  FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION_SUCCESS: 'FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION_SUCCESS',
  FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION_FAIL: 'FETCH_ADD_OR_EDIT_ADVERT_SUBMISSION_FAIL',
};

export default advertsActionTypes;
